const TANK_IDS_FILTER = "tankIds"
const COMPANY_ID_FILTER = "companyId"
const DEPO_FILTER = "depoId"
const DRIVER_IDS_FILTER = "driverIds"
const DEVICE_ID_FILTER = "deviceId"

export const filterService = {
    TANK_IDS_FILTER,
    COMPANY_ID_FILTER,
    DEPO_FILTER,
    DRIVER_IDS_FILTER,
    DEVICE_ID_FILTER,
    createFilterByFuelTanks,
    createFilterByCompanies,
    createFilterByDepos,
    createFilterByDrivers,
    createFilterByDevices,
    createFilterValues,
    getFilterValuesByFuelTanks,
    getFilterValuesByCompanies,
    getFilterValuesByDepos,
    getFilterValuesByDrivers,
    getFilterValuesByDevices
};

function createFilterByFuelTanks(fuelTanks) {
    const filter = [];

    const countCompanies = getCountCompanies(fuelTanks);
    const countDepos = getCountDepos(fuelTanks);

    for (let i = 0; i < fuelTanks.length; i++) {
        let label;

        if (countCompanies == 1) {
            label = countDepos == 1 ? `${fuelTanks[i].fuelTankName}` : `${fuelTanks[i].depoName}:${fuelTanks[i].fuelTankName}`;
        }
        else { label = `${fuelTanks[i].depoName}:${fuelTanks[i].fuelTankName}`; }

        filter.push({
            key: `${fuelTanks[i].vehicleId}:${fuelTanks[i].fuelTankId}`,
            label: label
        });
    }

    return filter.sort(function (a, b) {
        return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    });
}

function createFilterByCompanies(fuelTanks) {
    const filter = [];

    for (let i = 0; i < fuelTanks.length; i++) {
        const item = filter.find(x => x.key == fuelTanks[i].companyId);

        if (!item) {
            filter.push({
                key: fuelTanks[i].companyId,
                label: fuelTanks[i].companyName
            });
        }
    }

    return filter.sort(function (a, b) {
        return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    });
}

function createFilterByDepos(fuelTanks) {
    const filter = [];

    const countCompanies = getCountCompanies(fuelTanks);

    for (let i = 0; i < fuelTanks.length; i++) {
        const item = filter.find(x => x.key == fuelTanks[i].depoId);

        if (!item) {
            filter.push({
                key: fuelTanks[i].depoId,
                label: countCompanies == 1 ? `${fuelTanks[i].depoName}` : `${fuelTanks[i].companyName}:${fuelTanks[i].depoName}`
            });
        }
    }

    return filter.sort(function (a, b) {
        return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    });
}

function createFilterByDrivers(drivers) {
    const filter = [];

    for (let i = 0; i < drivers.length; i++) {
        filter.push({
            key: drivers[i].id,
            label: drivers[i].fullName
        });
    }

    return filter.sort(function (a, b) {
        return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    });
}

function createFilterByDevices(devices) {
    const filter = [];

    for (let i = 0; i < devices.length; i++) {
        filter.push({
            key: devices[i].id,
            label: devices[i].name
        });
    }

    return filter.sort(function (a, b) {
        return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    });
}

function createFilterValues(data) {
    const filterValues = [];

    const filterValue = JSON.parse(data);

    if (filterValue.type == "array") {
        for (let i = 0; i < filterValue.data.length; i++) {
            if (filterValue.data[i].isActive) {
                filterValues.push({
                    key: filterValue.data[i].key,
                    label: filterValue.data[i].value,
                });
            }
        }
    }
}

function getFilterValuesByFuelTanks(data) {
    return data.values.map(x => x.key).join(",");
}

function getFilterValuesByCompanies(fuelTanks, data) {
    const filterValues = [];

    for (let i = 0; i < data.values.length; i++) {
        const items = fuelTanks.filter(x => x.companyId == data.values[i].key);

        for (let j = 0; j < items.length; j++) {
            filterValues.push({
                key: `${items[j].vehicleId}:${items[j].fuelTankId}`
            })
        }
    }

    return filterValues.map(x => x.key).join(",");
}

function getFilterValuesByDepos(fuelTanks, data) {
    const filterValues = [];

    for (let i = 0; i < data.values.length; i++) {
        const items = fuelTanks.filter(x => x.depoId == data.values[i].key);

        for (let j = 0; j < items.length; j++) {
            filterValues.push({
                key: `${items[j].vehicleId}:${items[j].fuelTankId}`
            })
        }
    }

    return filterValues.map(x => x.key).join(",");
}

function getFilterValuesByDrivers(data) {
    return data.values.map(x => x.key).join(",");
}

function getFilterValuesByDevices(data) {
    return data.values.map(x => x.key).join(",");
}

function getCountCompanies(fuelTanks) {
    const uniqueCompanyIds = [];

    for (let i = 0; i < fuelTanks.length; i++) {
        if (!uniqueCompanyIds.includes(fuelTanks[i].companyId)) {
            uniqueCompanyIds.push(fuelTanks[i].companyId);
        }
    }

    return uniqueCompanyIds.length;
}

function getCountDepos(fuelTanks) {
    const uniqueDepoIds = [];

    for (let i = 0; i < fuelTanks.length; i++) {
        if (!uniqueDepoIds.includes(fuelTanks[i].depoId)) {
            uniqueDepoIds.push(fuelTanks[i].depoId);
        }
    }

    return uniqueDepoIds.length;
}
